import state from './moduleGradeControlState.js'
import mutations from './moduleGradeControlMutations.js'
import actions from './moduleGradeControlActions.js'
import getters from './moduleGradeControlGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

